import { transformEventForSegment } from './event-transformation';
import { contextToOptions } from './context-to-options';
export async function trackEventToSegment(segment, event) {
  const segmentAnalyticsCall = transformEventForSegment(event);
  if (!segmentAnalyticsCall) {
    return null;
  }
  const {
    method,
    parameters
  } = segmentAnalyticsCall;
  switch (method) {
    case 'identify':
      return segment.identify(...parameters);
    case 'reset':
      return segment.reset();
    case 'track':
      {
        const [eventName, properties, ctx] = parameters;
        return segment.track(eventName, properties, contextToOptions(ctx));
      }
    default:
      {
        const _exhaustive = method;
        return _exhaustive;
      }
  }
}